export default __webpack_public_path__ + "static/media/sorrento fluted panel.233c373c.png";